import React, { useState } from 'react';
import { Button, Row, Col } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import DownloadVariantsCSVModal from './DownloadVariantsCSVModal';

const VariantsDownloader = () => {
    const [downloadModalVisible, setDownloadModalVisible] = useState(false);

    const showDownloadModal = () => {
        setDownloadModalVisible(true);
    };

    const handleDownloadModalCancel = () => {
        setDownloadModalVisible(false);
    };

    return (
        <>
            <Row gutter={16} style={{ padding: 10 }}>
                <Col span={8}><strong>Download Published Variants CSV</strong></Col>
                <Col span={8}>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={showDownloadModal}
                    >
                        Download CSV
                    </Button>
                </Col>
                <Col span={8}>
                    {/* Spazio vuoto per mantenere l'allineamento */}
                </Col>
            </Row>

            <DownloadVariantsCSVModal
                visible={downloadModalVisible}
                onCancel={handleDownloadModalCancel}
            />
        </>
    );
};

export default VariantsDownloader; 